import {
    OPEN_CLOSE_GIFT_FOR_YOU_MODAL,
    OPEN_CLOSE_MYOFFERS_LIST_MODAL,
    OPEN_CLOSE_MYOFFERS_MODAL,
    OPEN_CLOSE_TERMS_AND_CONDITIONS_MODAL,
    SELECT_PROMO_BET, SELECT_TC_PROMO_ID,DO_NOT_SHOW_CHECK
} from '../constants/actionTypes';

import {REMOVE_PROMO_BET,APPLY_PROMO_BET,SELECTED_BET} from '../ui-modules/sports-book/constants/actionTypes'

export function openCloseMyOfferList() {
    return {type: OPEN_CLOSE_MYOFFERS_LIST_MODAL};
}
export function openCloseMyOffer() {
    return {type: OPEN_CLOSE_MYOFFERS_MODAL};
}
export function openGiftForYou() {
    return {type: OPEN_CLOSE_GIFT_FOR_YOU_MODAL};
}
export function openTermsAndConditions() {
    return {type: OPEN_CLOSE_TERMS_AND_CONDITIONS_MODAL};
}
export function applyPromoBet(bet,promoId,minorCurrencyUnits, systemLanguage, systemCurrency) {
    return {type: APPLY_PROMO_BET, bet,promoId,minorCurrencyUnits, systemLanguage, systemCurrency};
}
export function onSelectPromoList(promoId){
    return {type: SELECT_PROMO_BET, promoId};
}
export function setSetectedBet(bet){
    return {type: SELECTED_BET, bet};
}
export function setSelectedTCPromoId(selectedTCPromoId){
    return {type: SELECT_TC_PROMO_ID, selectedTCPromoId};
}
export function removePromoBet(bet,minorCurrencyUnits, systemLanguage, systemCurrency){
    return {type: REMOVE_PROMO_BET, bet,minorCurrencyUnits, systemLanguage, systemCurrency};
}
export function doNotShowCheckBox(){
    return {type: DO_NOT_SHOW_CHECK};
}


// WEBPACK FOOTER //
// ./src/actions/promoBetActions.js